// HelpButton.jsx
import { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { QuestionIcon } from "@primer/octicons-react";
import QuestionModal from "./QuestionModal";
import '../App.css';

function HelpButton( { showHint = false } ) {
  const [showModal, setShowModal] = useState(false);
  const [highlight, setHighlight] = useState(true);

  useEffect(() => {
    const clicked = localStorage.getItem("helpButtonClicked") === "true";
    setHighlight(!clicked); // 클릭했으면 false
  }, []);

  const handleClick = () => {
    setShowModal(true);
    setHighlight(false);
    localStorage.setItem("helpButtonClicked", "true");
  };

  return (
    <>
      <Button
        onClick={handleClick}
        variant="primary"
        size="sm"
        className={highlight ? "highlight-btn" : ""}
        style={{
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          padding: "0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "-12px",
        }}
      >
        <QuestionIcon size={24} />
      </Button>
      <QuestionModal show={showModal} 
      handleClose={() => setShowModal(false)}
      showHint={showHint}  // hint 버튼 표시 여부 전달
     />
    </>
  );
}

export default HelpButton;
